import passwordRules from "@/utils/validatePassword";

/**
 * Reference: https://github.com/wearebraid/vue-formulate-i18n/blob/master/src/locales/en.js
 * This is an object of functions that each produce valid responses. There's no
 * need for these to be 1-1 with english, feel free to change the wording or
 * use/not use any of the variables available in the object or the
 * arguments for the message to make the most sense in your language and culture.
 *
 * The validation context object includes the following properties:
 * {
 *   args        // Array of rule arguments: between:5,10 (args are ['5', '10'])
 *   name:       // The validation name to be used
 *   value:      // The value of the field (do not mutate!),
 *   vm: the     // FormulateInput instance this belongs to,
 *   formValues: // If wrapped in a FormulateForm, the value of other form fields.
 * }
 */
const localizedValidationMessages = {
  passwordHasLength: () =>
    `密码最少一共需要 ${passwordRules.requiredPasswordLength}个字符。`,
  passwordHasNumber: () =>
    `密码最少一共需要 ${passwordRules.requiredNumbers}个数字。`,
  passwordHasSpecial: () =>
    `密码最少一共需要 ${passwordRules.requiredSpecialChars}个特殊字符。`,
  passwordHasUppercase: () =>
    `密码最少一共需要 ${passwordRules.requiredUppercaseChars}个大写字符。`,
  passwordHasLowercase: () =>
    `密码最少一共需要 ${passwordRules.requiredLowercaseChars}个小写字符。`,
  passwordConfirm: () => "密码不匹配。",
};

export default localizedValidationMessages;
